module.exports = __webpack_public_path__ + "img/左1logo.23a72c09.png";